/* src/app/header/header.component.scss */
header {
  position: sticky;
  top: 0;
  z-index: 9999;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  margin: 0 -1rem;
  background-color: rgba(235, 241, 248, 0.95);
}
header > div {
  display: flex;
  padding: 0 1rem;
}
/*# sourceMappingURL=header.component.css.map */
